/** Prefix for DevTools filter: `[ff-ivs-screen-bridge]` */
const LOG_PREFIX = '[ff-ivs-screen-bridge]';

function getSendMessageToUnity(): ((g: string, m: string, p?: string | number) => void) | undefined {
  if (typeof window === 'undefined') return undefined;
  const fn = (window as unknown as { sendMessageToUnity?: (g: string, m: string, p?: string | number) => void })
    .sendMessageToUnity;
  return typeof fn === 'function' ? fn : undefined;
}

/**
 * Notifies Unity (Mirror → NetworkedStreamController) which IVS participant id is publishing screen share,
 * so AVPro/ivs.js uses that id for audio gating instead of the stale visuals_participant_id from stage info.
 */
export function sendIvsScreenSharePublisherToUnity(
  participantId: string,
  active: boolean,
  source: string
): boolean {
  const trimmed = participantId.trim();
  const send = getSendMessageToUnity();
  if (!send) {
    console.warn(LOG_PREFIX, source, 'sendMessageToUnity not available');
    return false;
  }
  if (active && !trimmed) {
    console.warn(LOG_PREFIX, source, 'active=true but empty participantId');
    return false;
  }
  const envelope = JSON.stringify({
    eventType: 'IvsScreenSharePublisher',
    payload: JSON.stringify({ participantId: trimmed, active }),
  });
  try {
    send('BrowserBridge', 'ReceivePayload', envelope);
    console.info(LOG_PREFIX, source, 'ReceivePayload dispatched', { active, participantId: trimmed });
    return true;
  } catch (e) {
    console.error(LOG_PREFIX, source, 'SendMessage threw', e);
    return false;
  }
}

/** Retries help when Unity LocalPlayer / sendMessageToUnity is not ready the instant IVS publish completes. */
export function sendIvsScreenSharePublisherToUnityWithRetries(
  participantId: string,
  active: boolean,
  source: string
): void {
  const delaysMs = [0, 400, 1200, 3000];
  delaysMs.forEach((ms, index) => {
    window.setTimeout(() => {
      sendIvsScreenSharePublisherToUnity(participantId, active, `${source}-t${ms}ms#${index}`);
    }, ms);
  });
}
